import React from "react";

import { getContractYearLabel } from "shared/util/relationaldata";

const ContractInfo = ({ contract, paidAmount, leftAmount }) => {
  return (
    <React.Fragment>
      {contract && (
        <div className="card horizontal-flex align-items-center justify-content-between" style={{ width: "100%" }}>
          <div className="horizontal-flex align-items-center justify-content-start" style={{ gap: "40px", flex: 10 }}>
            <h4 style={{ margin: "0px" }}>{contract?.school?.name || "-"}</h4>
            <span>
              <strong>Dönem:</strong> {getContractYearLabel(contract?.year) || "-"}
            </span>
            <span>
              <strong>Öğrenci:</strong> {contract?.student?.name || "-"}
            </span>
            <span>
              <strong>Fatura:</strong> {contract?.payerName ? contract?.payerName.slice(0, 20) : "-"}
            </span>
            <span>
              <strong>Toplam:</strong> {contract?.finalAmount ? contract.finalAmount + " TL" : "-"}
            </span>
            <span>
              <strong>Ödenen:</strong> {paidAmount ? paidAmount + " TL" : "-"}
            </span>
            <span>
              <strong>Kalan:</strong> {leftAmount ? leftAmount + " TL" : "-"}
            </span>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ContractInfo;
